import React, { useEffect, useState } from 'react';
import About from './about.js';
import Publication from './publication.js';
import './generalPrototype.css';
import background from './img/background.jpg';
import selfie from './img/selfie0.jpg';
import aboutIcon from './img/user.png';
import publicationsIcon from './img/feather-pen.png';
import cvIcon from './img/resume.png';
import cvPdf from './pdf/Anran_CV.pdf';

const CONTENT_BREAKPOINT = Number.MAX_SAFE_INTEGER;

function OrbitNavigation({ compact = false, activeView, onNavigate }) {
  return (
    <nav
      className={`prototype-orbit ${compact ? 'prototype-orbit--compact' : ''}`}
      aria-label="Primary navigation"
    >
      <button
        type="button"
        className="prototype-orbit__portrait"
        onClick={() => onNavigate('home')}
        aria-label="Return to the homepage"
        title="Home"
      >
        <img src={selfie} alt="Anran Xu" />
      </button>

      <button
        type="button"
        className={`prototype-orbit__node prototype-orbit__node--about ${activeView === 'about' ? 'is-active' : ''}`}
        onClick={() => onNavigate('about')}
        aria-current={activeView === 'about' ? 'page' : undefined}
      >
        <span className="prototype-orbit__icon">
          <img src={aboutIcon} alt="" />
        </span>
        <span className="prototype-orbit__label">About</span>
      </button>

      <button
        type="button"
        className={`prototype-orbit__node prototype-orbit__node--publications ${activeView === 'publications' ? 'is-active' : ''}`}
        onClick={() => onNavigate('publications')}
        aria-current={activeView === 'publications' ? 'page' : undefined}
      >
        <span className="prototype-orbit__icon">
          <img src={publicationsIcon} alt="" />
        </span>
        <span className="prototype-orbit__label">Publications</span>
      </button>

      <a
        className="prototype-orbit__node prototype-orbit__node--cv"
        href={cvPdf}
        target="_blank"
        rel="noopener noreferrer"
      >
        <span className="prototype-orbit__icon">
          <img src={cvIcon} alt="" />
        </span>
        <span className="prototype-orbit__label">CV</span>
      </a>
    </nav>
  );
}

function SocialLinks() {
  return (
    <div className="prototype-social" aria-label="Contact and profile links">
      <a href="mailto:anran.xu@riken.jp">Email</a>
      <a href="https://scholar.google.com/citations?user=LKunPoQAAAAJ&hl=en&oi=ao" target="_blank" rel="noopener noreferrer">Google Scholar</a>
      <a href="https://github.com/AnranXu" target="_blank" rel="noopener noreferrer">GitHub</a>
      <a href="https://twitter.com/AnranXu3" target="_blank" rel="noopener noreferrer">X</a>
    </div>
  );
}

function GeneralPrototype() {
  const [activeView, setActiveView] = useState('home');

  useEffect(() => {
    document.body.classList.add('prototype-active');
    return () => document.body.classList.remove('prototype-active');
  }, []);

  const navigate = (view) => {
    setActiveView(view);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (activeView === 'home') {
    return (
      <main
        className="prototype-home"
        style={{ '--prototype-background': `url(${background})` }}
      >
        <div className="prototype-home__overlay" aria-hidden="true" />
        <div className="prototype-home__layout">
          <section className="prototype-intro" aria-labelledby="prototype-title">
            <p className="prototype-eyebrow">RIKEN Center for Advanced Intelligence Project</p>
            <h1 id="prototype-title">
              Anran Xu
              <span>徐 安然</span>
            </h1>
            <p className="prototype-role">Special Postdoctoral Researcher</p>
            <p className="prototype-statement">
              Exploring privacy, usable security, and human-centered AI through interactive systems.
            </p>
            <div className="prototype-topics" aria-label="Research interests">
              <span>HCI</span>
              <span>Privacy</span>
              <span>AI Safety</span>
            </div>
            <SocialLinks />
          </section>

          <section className="prototype-orbit-stage" aria-label="Explore the website">
            <OrbitNavigation activeView={activeView} onNavigate={navigate} />
          </section>
        </div>
      </main>
    );
  }

  return (
    <main className="prototype-workspace">
      <aside
        className="prototype-rail"
        style={{ '--prototype-background': `url(${background})` }}
      >
        <div className="prototype-rail__overlay" aria-hidden="true" />
        <div className="prototype-rail__content">
          <button type="button" className="prototype-wordmark" onClick={() => navigate('home')}>
            <strong>Anran Xu</strong>
            <span>Special Postdoctoral Researcher</span>
          </button>
          <OrbitNavigation compact activeView={activeView} onNavigate={navigate} />
          <SocialLinks />
        </div>
      </aside>

      <section className="prototype-content" aria-live="polite">
        <About show={activeView === 'about'} xlBoundary={CONTENT_BREAKPOINT} />
        <Publication show={activeView === 'publications'} xlBoundary={CONTENT_BREAKPOINT} />
      </section>
    </main>
  );
}

export default GeneralPrototype;
